/**
 * Pictures the editor's canvas stands in for. Customize fills an empty picture setting with an
 * address under this prefix in the request it draws, never in what it saves, so the canvas shows
 * where a picture goes and which setting it fills (the rest of the address). It passes the page's
 * image checks like any Drate asset, is never fetched, and draws nothing outside the canvas.
 */
const canvasPlaceholderPrefix = "https://cdn.drate.app/_canvas/placeholder/";

export function canvasPlaceholder(setting: string) {
  return `${canvasPlaceholderPrefix}${setting}`;
}

/** The setting a stand-in picture fills (`imageUrl`, `images.2.url`), or null for a real one. */
export function canvasPlaceholderSetting(src: string | undefined | null) {
  return src?.startsWith(canvasPlaceholderPrefix)
    ? src.slice(canvasPlaceholderPrefix.length)
    : null;
}
